<template>
  <div>
       <header v-show="$route.path==='/administrator/new-email' || $route.path==='/administrator/edit-email/' + this.$route.params.id ? false : true">
         <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-3 border-bottom border-dark">
            <h2 class="m-0">会員一覧</h2>
            <router-link class="text-white" to="/administrator/new-member"><b-button class="px-4 py-2" variant="primary">新規追加</b-button></router-link>
        </div>
       </header>
       <div class="select-content mb-3">
         <div class="container-fluid px-3 py-2 bg-light text-dark">
           <b-row>
            <b-col lg="2">
              <b-form-input v-model="memberFilters.fullname" placeholder="氏名" @change="changeFilter"></b-form-input>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.country" @change="changeCountry">
                <b-form-select-option :value="null">国名</b-form-select-option>
                <b-form-select-option v-for="(country, index) in countries" :key="index" :value="country">{{country}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.prefecture" :disabled="memberFilters.country !== 'Japan'" @change="changeFilter">
                <b-form-select-option :value="null" text-danger>都道府県</b-form-select-option>
                <b-form-select-option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.age" class="form-select" @change="changeFilter">
                <b-form-select-option :value="null" disabled="disabled" selected>年齢</b-form-select-option>
                <b-form-select-option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.gender" @change="changeFilter">
                <b-form-select-option :value="null" disabled>性別</b-form-select-option>
                <b-form-select-option value="Male">男性</b-form-select-option>
                <b-form-select-option value="Female">女性</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.property_use" :options="property_use" @change="changeFilter"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col lg="2">
              <b-form-select v-model="memberFilters.property_types" :options="property_types" @change="changeFilter"></b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.price_range" :options="price" @change="changeFilter"></b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.business_types" :options="business_types" @change="changeFilter"></b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.area" @change="changeFilter">
                <b-form-select-option :value="null">エリア</b-form-select-option>
                <b-form-select-option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.plan" @change="changeFilter">
                <b-form-select-option v-for="(plan, index) in plans" :key="index" :value="plan.value">{{plan.text}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
              <b-form-select v-model="memberFilters.languages" @change="changeFilter" :options="languages"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col lg="2">
              <b-form-select v-model="memberFilters.email" @change="changeFilter">
                <b-form-select-option :value="null">メッセージ</b-form-select-option>
                <b-form-select-option value="ok">OK</b-form-select-option>
                <b-form-select-option value="ng">NG</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2">
               <b-form-select v-model="memberFilters.memberRegistrationDate" :options="memberRegistrationDateOptions" @change="changeFilter"></b-form-select>
            </b-col>
            <b-col lg="2">
              <b-button class="w-100" variant="success" @click="filterReset">リセット</b-button>
            </b-col>
          </b-row>
         </div>
       </div>
       <div class="alert">検索件数：{{ filteredPeople.length }}名</div>
       <div class="responsive-table">
          <b-table id="my-table" responsive bordered head-variant="p-3 mb-2 bg-light text-dark"
            :items="filteredPeople"
            :per-page="showAll"
            :current-page="currentPage"
            :fields="fields"
            ref="memberTable"
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            hover
          >
            <template #cell(selected)="row">
                <b-form-checkbox size="lg" v-model="selected" :value="row.item"/>
            </template>
            <template #head(selected)="">
                <b-form-checkbox size="lg" v-model="selectAll" @change="select"><span></span></b-form-checkbox>
            </template>
            <template #cell(memberinfo.fullname)="row">
                <router-link class="text-dark" :to="'/administrator/edit-member/' + row.item.id"> {{ row.value }}</router-link>
            </template>
            <template #head(memberinfo.countryAndPrefecture)="">
              国名<br>都道府県
            </template>
            <template #cell(memberinfo.countryAndPrefecture)="row">
                {{ row.item.memberinfo.country }}<br>
                {{ row.item.memberinfo.prefectures }}
            </template>
            <template #head(memberinfo.properties)="">
              物件用途<br>検討物件
            </template>
            <template #cell(memberinfo.properties)="row">
                {{ $i18n.t(row.item.memberinfo.use_of_the_property) }}<br>
                {{ row.item.memberinfo.types_of_properties }}
            </template>
            <template #cell(memberinfo.business_type)="row">
                <span v-if="row.item.memberinfo.business_type_developer">{{ $i18n.t('business_type_developer') }}<br></span>
                <span v-if="row.item.memberinfo.business_type_mediator">{{ $i18n.t('business_type_mediator') }}<br></span>
                <span v-if="row.item.memberinfo.business_type_indivisual">{{ $i18n.t('business_type_indivisual') }}</span>
            </template>
            <template #cell(memberinfo.plan)="row">
              {{ planName(row) }}
            </template>
          </b-table>
       </div>
       <footer class="pt-3" v-show="$route.path==='/administrator/new-email' || $route.path==='/administrator/edit-email/' + this.$route.params.id ? false : true">
         <div class="d-flex justify-content-between align-items-center my-3">
            <b-button class="btn-general p-3" variant="primary" @click="redirectToMagazine">新規メッセージへ</b-button>
            <div v-if="allMember">
              <b-pagination class="position-relative" align="center" size="lg"
                v-model="currentPage"
                :total-rows="filteredPeople.length"
                :per-page="perPage"
                :limit="4"
                :show-step-links="true"
                aria-controls
                first-number
                last-number
                v-show="pages"
              >
              <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
              <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
              </b-pagination>
            </div>
            <b-button class="btn-general p-3" variant="primary" @click="exportCsv" :disabled="buttonState()">Excelエクスポート</b-button>
          </div>
       </footer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { languages, memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../../assets/data/values'

export default {
  data () {
    return {
      languages: [{ text: '言語', disabled: true }].concat(languages.map(l => { return { value: l, text: this.$i18n.t(l) } })),
      property_use: [{ text: '物件用途' }].concat(propertyUses.map(u => { return { value: u, text: this.$i18n.t(u) } })),
      ageSetup: memberAges,
      property_types: [{ text: '検討物件' }].concat(Object.values(businessPropertyValues.propertyTypes).flat().map(t => this.$i18n.t(t))),
      price: [{ text: '価格帯' }].concat(propertyPrices.map(p => { return { value: p, text: this.$i18n.t(p) } })),
      business_types: [
        { value: null, text: '業種' },
        { value: 'business_type_indivisual', text: '個人' },
        { value: 'business_type_developer', text: '物件デベロッパー' },
        { value: 'business_type_mediator', text: '物件仲介' }
      ],
      plans: [
        { value: null, text: 'プラン' },
        { value: 'free', text: '無料プラン' },
        { value: 'set_plan_platinum', text: 'セットプラン（プラチナ）' },
        { value: 'set_plan_gold', text: 'セットプラン（ゴールド）' },
        { value: 'set_plan_silver', text: 'セットプラン（シルバー）' },
        { value: 'single_plan_lite', text: '個別プラン（ライト）' },
        { value: 'single_plan_basic', text: '個別プラン（ベーシック）' },
        { value: 'single_plan_business', text: '個別プラン（ビジネス）' },
        { value: 'single_plan_expoert', text: '個別プラン（エキスパート）' }
      ],
      fields: [
        { key: 'selected', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.fullname', label: '氏名', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.countryAndPrefecture', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.age', label: '年齢', thStyle: { background: '#F8F9FA' } },
        {
          key: 'memberinfo.gender',
          label: '性別',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value.toLowerCase())
          }
        },
        {
          key: 'memberinfo.properties',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.desired_price_range',
          label: '価格帯',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.business_type',
          label: '業種',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.area',
          label: 'エリア',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.plan',
          label: 'プラン',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.language',
          label: '言語',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.email_magazine_delivery',
          label: 'メッセージ',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            if (value) {
              return value.toUpperCase()
            }
          }
        },
        {
          key: 'created_at',
          label: '会員登録日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return value.substring(0, 10).replace(/-/g, '/')
          }
        }
      ],
      rows: 8,
      perPage: 30,
      allPage: null,
      currentPage: 1,
      totalRows: 1,
      mylist: [],
      selectAll: false,
      selectMode: 'single',
      selected: [],
      exportData: {
        MemberList: []
      },
      memberFilters: {
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        price_range: null,
        purchase: null,
        property_use: null,
        memberRegistrationDate: null,
        business_types: null,
        area: null,
        plan: null
      },
      paginate: false
    }
  },
  created () {
    this.prefectureCountry()
  },
  computed: {
    ...mapState('adminAddMember', ['prefectures', 'countries']),
    ...mapState('latestMember', ['allMember', 'memberRegistrationDates']),
    memberRegistrationDateOptions: function () {
      return [{ value: null, text: '会員登録年月' }].concat(this.memberRegistrationDates.map(d => ({ value: d.replaceAll('/', '-'), text: d.replace('/', '年') + '月' })))
    },
    filteredPeople: function () {
      return this.allMember.data
        .filter(this.filterByGender)
        .filter(this.filterByEmail)
        .filter(this.filterByAge)
        .filter(this.filterByLanguages)
        .filter(this.filterByCountry)
        .filter(this.filterByPrefecture)
        .filter(this.filterByPropertyUse)
        .filter(this.filterByPropertyType)
        .filter(this.filterByPrice)
        .filter(this.filterByMemberRegistrationDate)
        .filter(this.filterByBusinessType)
        .filter(this.filterByArea)
        .filter(this.filterByPlan)
        .filter(this.filterByFullname)
    },
    pages: function () {
      if (this.filteredPeople.length <= 30) {
        return false
      } else {
        return true
      }
    },
    showAll: function () {
      if (this.$route.path === '/administrator/new-email') {
        return null
      } else {
        return this.perPage
      }
    }
  },
  mounted () {
    this.totalRows = this.allMember.length
  },
  methods: {
    ...mapActions('adminAddMember', ['prefectureCountry']),
    ...mapActions('latestMember', ['getAllMember', 'getCsv']),
    onRowSelected (items) {
      this.$router.push({ name: 'Edit Member', params: { id: items[0].id } })
    },
    redirectToMagazine () {
      this.$store.commit('adminMagazine/setMembers', this.selected)
      this.$router.push({ name: 'Create new email' })
    },
    select () {
      this.$refs.memberTable.clearSelected()
      this.selected = []
      if (!this.selectAll) {
        this.filteredPeople.forEach(p => {
          this.selected.push(p)
        })
      }
    },
    exportCsv () {
      this.mylist = []
      let n = 0
      while (n !== this.selected.length) {
        this.mylist.push(this.selected[n])
        n++
      }
      const csvData = this.mylist.map(el => [
        el.memberinfo.fullname,
        el.memberinfo.country,
        el.memberinfo.prefectures,
        el.memberinfo.address,
        el.memberinfo.age,
        this.$i18n.t(el.memberinfo.gender),
        this.$i18n.t(el.memberinfo.use_of_the_property),
        this.$i18n.t(el.memberinfo.types_of_properties),
        this.$i18n.t(el.memberinfo.desired_price_range),
        this.$i18n.t(el.memberinfo.when_to_consider_purchasing),
        this.$i18n.t(el.memberinfo.language),
        this.$i18n.t(el.memberinfo.email_magazine_delivery.toUpperCase()),
        this.moment(el.created_at).format('YYYY/MM/DD hh:mm:ss')
      ])
      this.exportData.MemberList = csvData
      this.getCsv(this.exportData)
    },
    arrayColumn (array, columnName) {
      return array.map(function (value, index) {
        return value[columnName]
      })
    },
    filterByAge: function (member) {
      if (this.memberFilters.age === null || this.memberFilters.age === '') {
        return true
      }
      return (member.memberinfo.age === Number(this.memberFilters.age))
    },
    filterByGender: function (member) {
      if (this.memberFilters.gender === null) {
        return true
      }
      return (member.memberinfo.gender === this.memberFilters.gender)
    },
    filterByEmail: function (member) {
      if (this.memberFilters.email === null) {
        return true
      }
      return (member.memberinfo.email_magazine_delivery === this.memberFilters.email)
    },
    filterByLanguages: function (member) {
      if (this.memberFilters.languages === null) {
        return true
      }
      return (member.memberinfo.language === this.memberFilters.languages)
    },
    filterByPropertyUse: function (member) {
      if (this.memberFilters.property_use === null) {
        return true
      }
      return (member.memberinfo.use_of_the_property === this.memberFilters.property_use)
    },
    filterByPrefecture: function (member) {
      if (this.memberFilters.prefecture === null) {
        return true
      }
      return (member.memberinfo.prefectures === this.memberFilters.prefecture)
    },
    filterByCountry: function (member) {
      if (this.memberFilters.country === null) {
        return true
      }
      return (member.memberinfo.country === this.memberFilters.country)
    },
    filterByPrice: function (member) {
      if (this.memberFilters.price_range === null) {
        return true
      }
      return (member.memberinfo.desired_price_range === this.memberFilters.price_range)
    },
    filterByPropertyType: function (member) {
      if (this.memberFilters.property_types === null) {
        return true
      }
      return (member.memberinfo.types_of_properties === this.memberFilters.property_types)
    },
    filterByMemberRegistrationDate: function (member) {
      if (this.memberFilters.memberRegistrationDate === null) {
        return true
      }
      return (member.created_at.startsWith(this.memberFilters.memberRegistrationDate))
    },
    filterByBusinessType: function (member) {
      if (this.memberFilters.business_types === 'business_type_indivisual') {
        return member.memberinfo.business_type_indivisual
      } else if (this.memberFilters.business_types === 'business_type_developer') {
        return member.memberinfo.business_type_developer
      } else if (this.memberFilters.business_types === 'business_type_mediator') {
        return member.memberinfo.business_type_mediator
      }
      return true
    },
    filterByArea: function (member) {
      if (this.memberFilters.area === null) {
        return true
      }
      return member.memberinfo.area === this.memberFilters.area
    },
    filterByPlan: function (member) {
      // 検索条件が未選択
      if (this.memberFilters.plan === null) {
        return true
      }

      // 無料プランで検索
      if (this.memberFilters.plan === 'free') {
        return member.contracts.length === 0
      }

      if (member.contracts.length > 0) {
        // lookup_keyには"set_plan_gold_ja"のような言語情報がついているので、
        // startsWithで検索すれば言語を問わずに検索ができる
        return member.contracts[0].price.lookup_key.startsWith(this.memberFilters.plan)
      }

      return false
    },
    filterByFullname: function (member) {
      const filterFullname = this.memberFilters.fullname
      if (!filterFullname) {
        return true
      }
      return member.memberinfo.fullname.indexOf(filterFullname) > -1
    },
    buttonState: function () {
      if (this.selected.length === 0) {
        return true
      } else {
        return false
      }
    },
    filterReset () {
      this.memberFilters = {
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        price_range: null,
        purchase: null,
        property_use: null,
        memberRegistrationDate: null,
        business_types: null,
        area: null,
        plan: null,
        fullname: null
      }
      this.changeFilter()
    },
    changeCountry () {
      if (this.memberFilters.country !== 'Japan') {
        this.memberFilters.prefecture = null
      }
      this.changeFilter()
    },
    changeFilter () {
      this.selected = []
      this.selectAll = false
    },
    planName (row) {
      if (row.item.privileged) {
        return 'リード社プラン'
      }
      return row.item.contracts[0] ? row.item.contracts[0].price.product.name : ''
    }
  }
}
</script>
